module.exports = __webpack_public_path__ + "img/angelica.a3d0ec10.png";